export default __webpack_public_path__ + "static/media/ocsb-change.9dffd831.svg";